
export class RadioItem {


    constructor(public label: string, public inputValue: string, public testId: string = '') {



    }

    setLabel(lab: string) {

        this.label = lab;

    }

    setInputValue(val: string) {

        this.inputValue = val;

    }

    getLabel() {

        return this.label;

    }

    getInputValue() {

        return this.inputValue;

    }

}